export default __webpack_public_path__ + "static/footer-scooter-sharkfin-6bcae2bbdff51ad09c94a812e9ca1394.png";